module.exports = __webpack_public_path__ + "static/media/siggraph-19.bf42150e.jpg";